import { render, staticRenderFns } from "./explain-results-header-row.component.vue?vue&type=template&id=cf99b444&scoped=true"
import script from "./explain-results-header-row.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-header-row.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-results-header-row.component.vue?vue&type=style&index=0&id=cf99b444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf99b444",
  null
  
)

export default component.exports